import { FC } from 'react';
import countryList from './countryList.json';

type DialCodeSelectProps = {
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value: string;
};

export const DialCodeSelect: FC<DialCodeSelectProps> = ({ onChange, value }) => {
  return (
    <div className="dial-code-container">
      <select className="dial-code-select" value={value} onChange={onChange}>
        {countryList.map((country) => (
          <option key={country.code_2} value={country.dial_code}>
            {country.flag_emoji} {country.name_es} {country.dial_code}
          </option>
        ))}
      </select>
      <span className="dial-code">{value}</span>
    </div>
  );
};
